import { z } from "zod";
import isMobilePhone from "validator/lib/isMobilePhone";


export const createNewsletterFormSchema = (t: any) => z.object({
  name: z.string().optional(),
  email: z.string().email(t('errors.invalidEmail')),
});

export const createContactFormSchema = (t: any) => z.object({
  name: z.string().trim().min(1, t("zodMessage.nameReq")).max(255),
  namaperusahaan: z.string().min(1, t("zodMessage.companyNameReq")),
  jabatan: z.string().min(1, t("zodMessage.jobTitleReq")),
  email: z.string().email(t("zodMessage.emailInvalid")).min(1, t("zodMessage.emailReq")),
  message: z.string().min(12, t("zodMessage.messageReq")),
});


export const createQuotationFormSchema = (t: any) => {
  return z.object({
    name: z.string().min(1, { message: t('error.nameRequired') }),
    companyname: z.string().optional(),
    jobtitle: z.string().optional(),
    email: z.string().email({ message: t('error.invalidEmail') }),
    phone: z.string().min(1, { message: t('error.phoneRequired') }),
    website: z.string().optional(),
    // Changed from string to array of strings for multiple service selection
    services: z.array(z.string()).min(1, { message: t('error.serviceRequired') }),
    message: z.string().min(1, { message: t('error.messageRequired') }),
  });
};


export const SearchFormSchema = z.object({
  query: z.string().optional(),
});
